import { Type } from "@sinclair/typebox";
import { AVATAR_SEED_MAX, DISPLAY_NAME_MAX } from "../limits";
export const ProfileGetResSchema = Type.Object({
    display_name: Type.Union([Type.String(), Type.Null()]),
    avatar_seed: Type.Union([Type.String(), Type.Null()]),
});
export const ProfileUpdateReqSchema = Type.Object({
    display_name: Type.Optional(Type.Union([
        Type.String({ minLength: 1, maxLength: DISPLAY_NAME_MAX }),
        Type.Null(),
    ])),
    avatar_seed: Type.Optional(Type.Union([
        Type.String({ minLength: 1, maxLength: AVATAR_SEED_MAX }),
        Type.Null(),
    ])),
});
export const ProfileUpdateResSchema = ProfileGetResSchema;
export const AccountDeleteResSchema = Type.Object({
    deleted: Type.Boolean(),
});
